import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/ui/icons/google-chrome-web-store.svg';
import _imports_1 from '../assets/images/ui/icons/firefox.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ed9c1b78"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("Get extension");

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Chrome, Edge, Opera & Chromium browsers");

var _hoisted_3 = {
  class: "d-flex flex-row align-items-center"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "store-icon me-2",
    src: _imports_0
  }, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Get Lucid extension from ");

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("strong", {
    class: "ms-1"
  }, "Chrome Web Store", -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("Firefox");

var _hoisted_8 = {
  class: "d-flex flex-row align-items-center pb-2"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "store-icon me-2",
    src: _imports_1
  }, null, -1);
});

var _hoisted_10 = /*#__PURE__*/_createTextVNode("Get Lucid extension from ");

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("strong", {
    class: "ms-1"
  }, "Firefox Add-ons", -1);
});

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" If your browser is not supported yet, feel free to notify us at ");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("support@llucid.io");

var _hoisted_14 = /*#__PURE__*/_createTextVNode(". ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("Close");

import { computed, ref } from "vue";
import { detect } from "detect-browser";
import { LogoFirefox, LogoChrome, LogoEdge } from "@vicons/ionicons5";
import { Opera } from "@vicons/fa";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var links = {
      chrome: process.env.VUE_APP_CHROME_STORE_URI,
      firefox: process.env.VUE_APP_FIREFOX_STORE_URI
    };
    var browser = detect();
    var modalVisible = ref(false);
    var hasIcon = computed(function () {
      return ["firefox", "chrome", "chromium", "edge", "edge-chromium", "opera"].includes((browser === null || browser === void 0 ? void 0 : browser.name.toLowerCase()) || "");
    });
    var isChromium = computed(function () {
      return ["chrome", "chromium", "edge", "edge-chromium", "chromium-webview", "opera", "brave", "yandexbrowser"].includes((browser === null || browser === void 0 ? void 0 : browser.name.toLowerCase()) || "");
    });

    var redirect = function redirect() {
      var link;
      if (isChromium.value) link = links.chrome;
      if ((browser === null || browser === void 0 ? void 0 : browser.name) === "firefox") link = links.firefox;

      if (link) {
        window.open(link, "_blank");
        return;
      }

      modalVisible.value = true;
    };

    return function (_ctx, _cache) {
      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_h5 = _resolveComponent("n-h5");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_a = _resolveComponent("n-a");

      var _component_n_hr = _resolveComponent("n-hr");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_modal = _resolveComponent("n-modal");

      return _openBlock(), _createBlock(_component_n_button, {
        type: "success",
        class: "extension-button",
        onClick: redirect
      }, _createSlots({
        default: _withCtx(function () {
          return [_createVNode(_component_n_text, {
            strong: ""
          }, {
            default: _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "default", {}, function () {
                return [_hoisted_1];
              })];
            }),
            _: 3
          }), _createVNode(_component_n_modal, {
            show: modalVisible.value,
            "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
              return modalVisible.value = $event;
            }),
            preset: "card",
            title: "Download Lucid extension",
            "auto-focus": false,
            class: "extension-modal"
          }, {
            footer: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                class: "mt-3",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return modalVisible.value = false;
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_15];
                }),
                _: 1
              })];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_n_h5, {
                strong: ""
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_n_a, {
                href: links.chrome,
                class: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_button, {
                    type: "info"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5, _hoisted_6];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["href"])]), _createVNode(_component_n_h5, {
                strong: ""
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              }), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_n_a, {
                href: links.firefox,
                class: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_button, {
                    type: "info"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_10, _hoisted_11];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["href"])]), _createVNode(_component_n_hr, {
                class: "mt-4"
              }), _createVNode(_component_n_p, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_text, {
                    depth: "3"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_12, _createVNode(_component_n_a, {
                        href: "mailto:support@llucid.io"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_13];
                        }),
                        _: 1
                      }), _hoisted_14];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 2
      }, [_unref(hasIcon) || !!_ctx.$slots.icon ? {
        name: "icon",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "icon", {}, function () {
            return [_createVNode(_component_n_icon, null, {
              default: _withCtx(function () {
                var _unref2, _unref3, _unref4, _unref5;

                return [['firefox'].includes((_unref2 = _unref(browser)) === null || _unref2 === void 0 ? void 0 : _unref2.name.toLowerCase()) ? (_openBlock(), _createBlock(_unref(LogoFirefox), {
                  key: 0
                })) : ['chrome', 'chromium'].includes((_unref3 = _unref(browser)) === null || _unref3 === void 0 ? void 0 : _unref3.name.toLowerCase()) ? (_openBlock(), _createBlock(_unref(LogoChrome), {
                  key: 1
                })) : ['edge-chromium'].includes((_unref4 = _unref(browser)) === null || _unref4 === void 0 ? void 0 : _unref4.name.toLowerCase()) ? (_openBlock(), _createBlock(_unref(LogoEdge), {
                  key: 2
                })) : ['opera'].includes((_unref5 = _unref(browser)) === null || _unref5 === void 0 ? void 0 : _unref5.name.toLowerCase()) ? (_openBlock(), _createBlock(_unref(Opera), {
                  key: 3
                })) : _createCommentVNode("", true)];
              }),
              _: 1
            })];
          })];
        })
      } : undefined]), 1024);
    };
  }
});